import React from 'react';
import { accountSearchColumns, khachHangSearchColumns, nhanVienSearchColumns, QUERY_KEYS } from '@/constants';
import { DateRangeDropdownV2, DocumentNumberRangeFieldV2, FormFieldV2 } from '@/components/custom/erp';
import { AccountModel, KhachHang, NhanVien } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  formMode: 'add' | 'edit' | 'view';
}

const BasicInfoTab = ({ formMode }: BasicInfoTabProps) => {
  return (
    <div className='p-4'>
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0'>Ngày c/từ (từ/đến)</Label>
        <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
      </div>

      <DocumentNumberRangeFieldV2
        label='Số c/từ (từ/đến)'
        fromName='so_ct1'
        toName='so_ct2'
        disabled={formMode === 'view'}
      />

      <div className='flex items-center'>
        <Label className='w-[150px]'>Diễn giải</Label>
        <div className='w-full'>
          <FormFieldV2 name='dien_giai' type='text' disabled={formMode === 'view'} />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
